import * as Joi from "joi-browser";
import { MdInfoOutline } from "react-icons/md";
import tickNew from "../assets/img/tick-new.svg";
import { Col } from "react-bootstrap";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import exclamation from "../assets/img/exclamation.svg";
import moment from "moment";

export const haveValue = (val) => {
  if (
    val !== "" &&
    val !== "undefined" &&
    val !== undefined &&
    val !== null &&
    val !== "null"
  ) {
    return true;
  } else {
    return false;
  }
};

export const withBackendUrl = (path, defaultPath = null) => {
  if (typeof path === "object") {
    let src = URL.createObjectURL(path);
    return src;
  } else {
    if (haveValue(path)) {
      path = path?.toString();
      if (path?.startsWith("http://") || path?.startsWith("https://")) {
        return path;
      } else {
        if (path.startsWith("/")) {
          path = path.substring(1);
        }
        return process.env.REACT_APP_SERVER_URL + "/" + path;
      }
    } else {
      return "";
    }
  }
};
export const toLowerCase = (data) => {
  return data.toString().toLowerCase();
};

export const convertCurrencyFormat = (amount) => {
  return new Intl.NumberFormat(localStorage.getItem("i18nextLng"), {
    currency: localStorage.getItem("i18nextLng") === "es" ? "EUR" : "USD",
  }).format(amount);
};

export const toUpperCase = (data) => {
  return data.toString().toUpperCase();
};

export const validateJOIFormField = (formFields, schema) => {
  const result = Joi.validate(formFields, schema, {
    abortEarly: false,
    stripUnknown: true,
  });
  const { error } = result;
  if (!error) {
    return null;
  } else {
    const errorData = {};
    for (let item of error.details) {
      const name = item.path[0];
      errorData[name] = item.message;
    }
    return errorData;
  }
};

export const validateJOIProperty = (schema, event) => {
  const { name, value } = event.target;
  console.log(value, "check iban value");
  const obj = { [name]: value };
  if (schema.hasOwnProperty(name)) {
    const subSchema = { [name]: schema[name] };
    const result = Joi.validate(obj, subSchema, {
      stripUnknown: true,
    });
    const { error } = result;
    return error ? error.details[0].message : null;
  } else {
    return null;
  }
};

export const renderErrorMessage = (errors, type) => {
  if (errors && errors[type]) {
    return errors[type];
  }
  return "";
};

export const getBaseUrl = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return baseUrl;
};

export const truncateString = (str, maxLength = 100) => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "...";
  }
  return str;
};

export const skipMaccUser = (user_type = null) => {
  switch (user_type) {
    case "macc":
      return true;
    default:
      return false;
  }
};

export const verifyDniNie = (user, nie_val) => {
  var result = false;
  if (user?.onfido_kyc_success) {
    if (user?.onfido_user_kyc?.onfido_doc_data?.personal_number == nie_val) {
      result = true;
    }
  }
  if (result == false) {
    if (user?.dni_nie == nie_val) {
      result = true;
    }
  }
  return result;
};

export const fetchCompanyName = (user, _t) => {
  var found = false;
  var res = null;
  if (haveValue(user?.vida_laboral_id)) {
    const response = user?.vida_laboral_id?.response;

    if (verifyDniNie(user, response?.informacionPersonal?.identificacion)) {
      const companyArr = user?.vida_laboral_id?.response?.situaciones;
      var company_name = null;
      for (let val of companyArr) {
        if (!haveValue(val?.fechaBaja)) {
          company_name = haveValue(val?.nombreEmpresa)
            ? val?.nombreEmpresa
            : "";
          break;
        }
      }
      if (haveValue(company_name)) {
        found = true;
        res = { type: "Vida Laboral", val: company_name };
      }
    }
  }
  if (
    found == false &&
    haveValue(user?.algoanIncome?.employers) &&
    user?.algoanIncome?.employers.length > 0
  ) {
    found = true;
    res = { type: "Bank", val: user?.algoanIncome?.employers[0]?.name };
  }
  if (found == false && haveValue(user?.name_of_company)) {
    found = true;
    res = { type: "", val: user?.name_of_company };
  }
  if (found == false) {
    res = null;
  }
  if (haveValue(res)) {
    return (
      <>
        <h4 className="d-flex gap-2 align-items-center">
          {_t("nameOfCompany")}
          {haveValue(res.type) && (
            <ul className="infodorpdown summarydropdum position-relative">
              <li>
                <button className="iconinfo">
                  <MdInfoOutline />
                </button>{" "}
              </li>
              <ul className="tooltip">
                <p>
                  {_t("from")} {_t(res.type)}
                </p>
              </ul>
            </ul>
          )}
          :
        </h4>
        <h3>
          <span>{res.val}</span>{" "}
          {haveValue(res.type) && <img src={tickNew} alt="" />}
        </h3>
      </>
    );
  }
};

function getMonthKey(monthNumber) {
  const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];
  return months[monthNumber - 1];
}

const normalizeSalary = (value) => {
  if (typeof value === "string") {
    value = value.replace(/,/g, ""); // Remove commas
  }
  return Math.ceil(parseFloat(value));
};

export const checkPayslipData = (user, _t) => {
  // console.log("data in payslip => tenant extra fields", user);
  const payslip_data = user?.tenant_extra_field_id?.payslip_data;

  return (
    <>
      <Col md={5}>
        <div className="Score-content-list">
          <h4>{_t("incomeFromPayslip")}:</h4>
          {/* paslip 1 data */}
          {haveValue(payslip_data?.payslip1) &&
            verifyDniNie(user, payslip_data?.payslip1?.data?.nieDniNumber) &&
            (() => {
              const payslip = payslip_data?.payslip1?.data;
              const situaciones =
                user?.vida_laboral_id?.response?.situaciones || [];

              const empresaVida = situaciones[0]?.nombreEmpresa
                ?.split(" ")[0]
                ?.toLowerCase();
              const empresaPayslip = payslip?.employer
                ?.split(" ")[0]
                ?.toLowerCase();

              const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
              const isEmployerMatch = empresaPayslip === empresaVida;

              const deductionData =
                user?.tenant_extra_field_id?.deduction_cert_data
                  ?.company_info || [];
              const payslipDate = payslip?.date;

              let isSalaryMatch = false;
              let isSalaryDataAvailable = false;

              if (payslipDate) {
                const [day, month, year] = payslipDate.includes("-")
                  ? payslipDate.split("-").length === 3 &&
                    payslipDate.split("-")[2].length === 4
                    ? payslipDate.split("-")
                    : payslipDate.split("-").reverse()
                  : ["", "", ""];

                const monthKey = getMonthKey(parseInt(month));
                const targetYear = year;

                for (const company of deductionData) {
                  const yearObj = company?.year;
                  const salaryValue = yearObj?.[targetYear]?.[monthKey];

                  if (salaryValue) {
                    isSalaryDataAvailable = true;

                    if (
                      normalizeSalary(salaryValue) ===
                      normalizeSalary(payslip?.grossSalary)
                    ) {
                      isSalaryMatch = true;
                      break;
                    }
                  }
                }
              }

              const hasBothData =
                isEmployerDataAvailable && isSalaryDataAvailable;
              const hasAnyData =
                isEmployerDataAvailable || isSalaryDataAvailable;

              const isBothMatch = isEmployerMatch && isSalaryMatch;
              const isEitherMismatch =
                (isEmployerDataAvailable && !isEmployerMatch) ||
                (isSalaryDataAvailable && !isSalaryMatch);

              return (
                <div className="d-flex payslip-style">
                  <span className="payslip-font-size-salary">
                    €{convertCurrencyFormat(payslip?.grossSalary)}
                  </span>
                  <span className="paysip-date payslip-font-size">
                    {payslip?.date
                      ? `(${moment(payslip.date, "DD-MM-YYYY").format(
                          "MMM, YYYY"
                        )})`
                      : ""}
                  </span>

                  {!hasAnyData ? null : (hasBothData && isBothMatch) ||
                    (!isEmployerDataAvailable &&
                      isSalaryDataAvailable &&
                      isSalaryMatch) ||
                    (!isSalaryDataAvailable &&
                      isEmployerDataAvailable &&
                      isEmployerMatch) ? (
                    <img src={tickNew} alt="match" />
                  ) : isEitherMismatch ? (
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <button className="iconinfo iconinfo2 m-0">
                          <img src={exclamation} alt="mismatch" />
                        </button>
                      </li>
                      <ul className="tooltip tooltip2">
                        {isEmployerDataAvailable && !isEmployerMatch && (
                          <p>{_t("companyNotMatch")}</p>
                        )}
                        {isSalaryDataAvailable && !isSalaryMatch && (
                          <p>{_t("salaryMismatch")}</p>
                        )}
                      </ul>
                    </ul>
                  ) : null}
                </div>
              );
            })()}

          {/* paslip 2 data */}
          {haveValue(payslip_data?.payslip2) &&
            verifyDniNie(user, payslip_data?.payslip2?.data?.nieDniNumber) &&
            (() => {
              const payslip = payslip_data?.payslip2?.data;
              const situaciones =
                user?.vida_laboral_id?.response?.situaciones || [];

              const empresaVida = situaciones[0]?.nombreEmpresa
                ?.split(" ")[0]
                ?.toLowerCase();
              const empresaPayslip = payslip?.employer
                ?.split(" ")[0]
                ?.toLowerCase();

              const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
              const isEmployerMatch = empresaPayslip === empresaVida;

              const deductionData =
                user?.tenant_extra_field_id?.deduction_cert_data
                  ?.company_info || [];
              const payslipDate = payslip?.date;

              let isSalaryMatch = false;
              let isSalaryDataAvailable = false;

              if (payslipDate) {
                const [day, month, year] = payslipDate.includes("-")
                  ? payslipDate.split("-").length === 3 &&
                    payslipDate.split("-")[2].length === 4
                    ? payslipDate.split("-")
                    : payslipDate.split("-").reverse()
                  : ["", "", ""];

                const monthKey = getMonthKey(parseInt(month));
                const targetYear = year;

                for (const company of deductionData) {
                  const yearObj = company?.year;
                  const salaryValue = yearObj?.[targetYear]?.[monthKey];

                  if (salaryValue) {
                    isSalaryDataAvailable = true;

                    if (
                      normalizeSalary(salaryValue) ===
                      normalizeSalary(payslip?.grossSalary)
                    ) {
                      isSalaryMatch = true;
                      break;
                    }
                  }
                }
              }

              const hasBothData =
                isEmployerDataAvailable && isSalaryDataAvailable;
              const hasAnyData =
                isEmployerDataAvailable || isSalaryDataAvailable;

              const isBothMatch = isEmployerMatch && isSalaryMatch;
              const isEitherMismatch =
                (isEmployerDataAvailable && !isEmployerMatch) ||
                (isSalaryDataAvailable && !isSalaryMatch);

              return (
                <div className="d-flex payslip-style">
                  <span className="payslip-font-size-salary">
                    €{convertCurrencyFormat(payslip?.grossSalary)}
                  </span>
                  <span className="paysip-date payslip-font-size">
                    {payslip?.date
                      ? `(${moment(payslip.date, "DD-MM-YYYY").format(
                          "MMM, YYYY"
                        )})`
                      : ""}
                  </span>

                  {!hasAnyData ? null : (hasBothData && isBothMatch) ||
                    (!isEmployerDataAvailable &&
                      isSalaryDataAvailable &&
                      isSalaryMatch) ||
                    (!isSalaryDataAvailable &&
                      isEmployerDataAvailable &&
                      isEmployerMatch) ? (
                    <img src={tickNew} alt="match" />
                  ) : isEitherMismatch ? (
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <button className="iconinfo iconinfo2 m-0">
                          <img src={exclamation} alt="mismatch" />
                        </button>
                      </li>
                      <ul className="tooltip tooltip2">
                        {isEmployerDataAvailable && !isEmployerMatch && (
                          <p>{_t("companyNotMatch")}</p>
                        )}
                        {isSalaryDataAvailable && !isSalaryMatch && (
                          <p>{_t("salaryMismatch")}</p>
                        )}
                      </ul>
                    </ul>
                  ) : null}
                </div>
              );
            })()}

          {/* paslip 3 data */}
          {haveValue(payslip_data?.payslip3) &&
            verifyDniNie(user, payslip_data?.payslip3?.data?.nieDniNumber) &&
            (() => {
              const payslip = payslip_data?.payslip3?.data;
              const situaciones =
                user?.vida_laboral_id?.response?.situaciones || [];

              const empresaVida = situaciones[0]?.nombreEmpresa
                ?.split(" ")[0]
                ?.toLowerCase();
              const empresaPayslip = payslip?.employer
                ?.split(" ")[0]
                ?.toLowerCase();

              const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
              const isEmployerMatch = empresaPayslip === empresaVida;

              const deductionData =
                user?.tenant_extra_field_id?.deduction_cert_data
                  ?.company_info || [];
              const payslipDate = payslip?.date;

              let isSalaryMatch = false;
              let isSalaryDataAvailable = false;

              if (payslipDate) {
                const [day, month, year] = payslipDate.includes("-")
                  ? payslipDate.split("-").length === 3 &&
                    payslipDate.split("-")[2].length === 4
                    ? payslipDate.split("-")
                    : payslipDate.split("-").reverse()
                  : ["", "", ""];

                const monthKey = getMonthKey(parseInt(month));
                const targetYear = year;

                for (const company of deductionData) {
                  const yearObj = company?.year;
                  const salaryValue = yearObj?.[targetYear]?.[monthKey];

                  if (salaryValue) {
                    isSalaryDataAvailable = true;

                    if (
                      normalizeSalary(salaryValue) ===
                      normalizeSalary(payslip?.grossSalary)
                    ) {
                      isSalaryMatch = true;
                      break;
                    }
                  }
                }
              }

              const hasBothData =
                isEmployerDataAvailable && isSalaryDataAvailable;
              const hasAnyData =
                isEmployerDataAvailable || isSalaryDataAvailable;

              const isBothMatch = isEmployerMatch && isSalaryMatch;
              const isEitherMismatch =
                (isEmployerDataAvailable && !isEmployerMatch) ||
                (isSalaryDataAvailable && !isSalaryMatch);

              return (
                <div className="d-flex payslip-style">
                  <span className="payslip-font-size-salary">
                    €{convertCurrencyFormat(payslip?.grossSalary)}
                  </span>
                  <span className="paysip-date payslip-font-size">
                    {payslip?.date
                      ? `(${moment(payslip.date, "DD-MM-YYYY").format(
                          "MMM, YYYY"
                        )})`
                      : ""}
                  </span>

                  {!hasAnyData ? null : (hasBothData && isBothMatch) ||
                    (!isEmployerDataAvailable &&
                      isSalaryDataAvailable &&
                      isSalaryMatch) ||
                    (!isSalaryDataAvailable &&
                      isEmployerDataAvailable &&
                      isEmployerMatch) ? (
                    <img src={tickNew} alt="match" />
                  ) : isEitherMismatch ? (
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <button className="iconinfo iconinfo2 m-0">
                          <img src={exclamation} alt="mismatch" />
                        </button>
                      </li>
                      <ul className="tooltip tooltip2">
                        {isEmployerDataAvailable && !isEmployerMatch && (
                          <p>{_t("companyNotMatch")}</p>
                        )}
                        {isSalaryDataAvailable && !isSalaryMatch && (
                          <p>{_t("salaryMismatch")}</p>
                        )}
                      </ul>
                    </ul>
                  ) : null}
                </div>
              );
            })()}
        </div>
      </Col>
    </>
  );
};

export const toCamelCase = (str) => {
  return str
    .replace(/[^\w\s]/g, "")
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, "");
};

export const validatePhoneNumber = (fullPhoneNumber) => {
  try {
    const phoneNumberWithPlus = `+${fullPhoneNumber}`;
    const phoneNumberObject = parsePhoneNumberFromString(phoneNumberWithPlus);
    if (phoneNumberObject && phoneNumberObject.isValid()) {
      return { isValid: true, message: "Valid phone number" };
    }
    return { isValid: false, message: "Invalid phone number." };
  } catch (error) {
    return { isValid: false, message: "Invalid phone number" };
  }
};

export const calculateEffortRate = (user_income, user, profile_data) => {
  if (haveValue(user_income) && haveValue(user)) {
    const percentage = haveValue(profile_data?.rent_percentage)
      ? profile_data?.rent_percentage
      : user?.rent_percentage;
    const effortAmount = (user_income * (percentage ?? 0)) / 100;
    return {
      annual_sal: user_income * 12,
      monthly_sal: user_income,
      effort_rate: percentage ?? 0,
      effort_amount: parseFloat(effortAmount.toFixed(2)),
    };
    // let one_month_sal = user_income;
    // let effort_perc = (rent / one_month_sal) * 100;
    // return {
    //   annual_sal: user_income * 12,
    //   monthly_sal: one_month_sal,
    //   // effort_rate: effort_perc,
    //   effort_rate: parseFloat(effort_perc.toFixed(2)),
    //   // effort_amount: (one_month_sal * effort_perc) / 100,
    //   effort_amount: rent,
    // };
  } else {
    return {
      annual_sal: "N/A",
      monthly_sal: "N/A",
      effort_rate: "N/A",
      effort_amount: "N/A",
    };
  }
};

export function nl2br(str) {
  if (typeof str !== "string") return "";
  return str.replace(/\n/g, "<br>");
}

const payslipValidityCheck = (payslip_data, user) => {
  const payslip = payslip_data?.data;
  const situaciones = user?.vida_laboral_id?.response?.situaciones || [];

  const empresaVida = situaciones[0]?.nombreEmpresa
    ?.split(" ")[0]
    ?.toLowerCase();
  const empresaPayslip = payslip?.employer?.split(" ")[0]?.toLowerCase();

  const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
  const isEmployerMatch = empresaPayslip === empresaVida;

  const deductionData =
    user?.tenant_extra_field_id?.deduction_cert_data?.company_info || [];
  const payslipDate = payslip?.date;

  let isSalaryMatch = false;
  let isSalaryDataAvailable = false;

  if (payslipDate) {
    const [day, month, year] = payslipDate.includes("-")
      ? payslipDate.split("-").length === 3 &&
        payslipDate.split("-")[2].length === 4
        ? payslipDate.split("-")
        : payslipDate.split("-").reverse()
      : ["", "", ""];

    const monthKey = getMonthKey(parseInt(month));
    const targetYear = year;

    for (const company of deductionData) {
      const yearObj = company?.year;
      const salaryValue = yearObj?.[targetYear]?.[monthKey];

      if (salaryValue) {
        isSalaryDataAvailable = true;

        if (
          normalizeSalary(salaryValue) === normalizeSalary(payslip?.grossSalary)
        ) {
          isSalaryMatch = true;
          break;
        }
      }
    }
  }

  const hasBothData = isEmployerDataAvailable && isSalaryDataAvailable;
  const hasAnyData = isEmployerDataAvailable || isSalaryDataAvailable;

  const isBothMatch = isEmployerMatch && isSalaryMatch;

  return !hasAnyData ? true : hasBothData && isBothMatch ? true : false;
};

export const getIncomeForEffortRate = (user) => {
  let tenantExtraField = user?.tenant_extra_field_id;
  if (haveValue(user?.algoanIncome?.monthlyAmount)) {
    return Number(user?.algoanIncome?.monthlyAmount);
  }
  if (haveValue(user?.gurantor_id?.algoanIncome?.monthlyAmount)) {
    return Number(user?.gurantor_id?.algoanIncome?.monthlyAmount);
  }
  // Check vals for modelo 100
  if (
    haveValue(user?.itr_status) &&
    haveValue(user?.itr_amount) &&
    user?.itr_status == "success"
  ) {
    if (verifyDniNie(user, user?.itr_dni_nie)) {
      console.log("ITR");
      return Number(user?.itr_amount / 12);
    }
  }
  if (
    haveValue(tenantExtraField?.payslip_data?.payslip1?.data?.grossSalary) ||
    haveValue(tenantExtraField?.payslip_data?.payslip2?.data?.grossSalary) ||
    haveValue(tenantExtraField?.payslip_data?.payslip3?.data?.grossSalary)
  ) {
    //Get the value of latest Payslip
    let payslip_data = null;
    if (
      verifyDniNie(
        user,
        tenantExtraField?.payslip_data?.payslip1?.data?.nieDniNumber
      )
    ) {
      payslip_data = tenantExtraField?.payslip_data?.payslip1?.data;
    } else if (
      verifyDniNie(
        user,
        tenantExtraField?.payslip_data?.payslip2?.data?.nieDniNumber
      )
    ) {
      payslip_data = tenantExtraField?.payslip_data?.payslip2?.data;
    } else if (
      verifyDniNie(
        user,
        tenantExtraField?.payslip_data?.payslip3?.data?.nieDniNumber
      )
    ) {
      payslip_data = tenantExtraField?.payslip_data?.payslip3?.data;
    }

    //Verify DNI/NIE with user and payslip else check in other method
    if (haveValue(payslip_data)) {
      console.log("Payslip", payslip_data);
      return payslip_data?.grossSalary;
    }
  }
  if (haveValue(user?.current_annual_income)) {
    console.log("Annual Income");
    return user?.current_annual_income / 12;
  }
  return null;
};
